import * as smoothy from "smoothy";

export function registerSmoothyLanguage(monaco) {
  monaco.languages.register({
    id: "smoothy",
  });

  var graphicsClasses = smoothy.graphicsClasses();

  var smoothyClasses = [];
  var smoothyClassesNames = [];
  for (var smoothyClass in graphicsClasses) {
    if (typeof graphicsClasses[smoothyClass] == "function" && graphicsClasses.hasOwnProperty(smoothyClass)) {
      smoothyClasses.push({
        name: smoothyClass,
        params: getArgs(graphicsClasses[smoothyClass]),
      });
      smoothyClassesNames.push(smoothyClass);
      smoothyClassesNames.push(smoothyClass.toLowerCase());
    }
  }

  function getArgs(func) {
    // First match everything inside the function argument parens.
    var args = func.toString().match(/function\s.*?\(([^)]*)\)/)[1];

    // Split the arguments string into an array comma delimited.
    return args
      .split(",")
      .map(function (arg) {
        // Ensure no inline comments are parsed and trim the whitespace.
        return arg.replace(/\/\*.*\*\//, "").trim();
      })
      .filter(function (arg) {
        // Ensure no undefined values are added.
        return arg;
      });
  }

  const getAllMethods = (obj) => {
    let props = [];

    do {
      const l = Object.getOwnPropertyNames(obj)
        .concat(Object.getOwnPropertySymbols(obj).map((s) => s.toString()))
        .sort()
        .filter(
          (p, i, arr) =>
            typeof obj[p] === "function" && //only the methods
            p !== "constructor" && //not the constructor
            (i == 0 || p !== arr[i - 1]) && //not overriding in this prototype
            props.indexOf(p) === -1 //not overridden in a child
        );
      props = props.concat(l);
    } while (
      (obj = Object.getPrototypeOf(obj)) && //walk-up the prototype chain
      Object.getPrototypeOf(obj) //not the the Object prototype methods (hasOwnProperty, etc...)
    );

    return props;
  };

  // Register a tokens provider for the language
  monaco.languages.setMonarchTokensProvider("smoothy", {
    keywords: ["var", "is"],
    typeKeywords: ["boolean", "number", "object", "string", "undefined"],
    operators: [
      "=",
      "??",
      "||",
      "&&",
      "|",
      "^",
      "&",
      "==",
      "!=",
      "<=",
      ">=",
      "<<",
      "+",
      "-",
      "*",
      "/",
      "%",
      "!",
      "~",
      "++",
      "--",
      "+=",
      "-=",
      "*=",
      "/=",
      "%=",
      "&=",
      "|=",
      "^=",
      "<<=",
      ">>=",
      ">>",
      "=>",
    ],
    SmoothyClasses: smoothyClassesNames,
    SmoothyMethods: ["Show", "show", "Recognize", "recognize", "Move", "move", "change"],
    SmoothyParams: ["id", "Id", "ID", "direction", "Direction", "distance", "Distance", "time", "Time"],
    symbols: /[=><!~?:&|+\-*\/\^%]+/,
    escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
    digits: /\d+(_+\d+)*/,
    octaldigits: /[0-7]+(_+[0-7]+)*/,
    binarydigits: /[0-1]+(_+[0-1]+)*/,
    hexdigits: /[[0-9a-fA-F]+(_+[0-9a-fA-F]+)*/,
    regexpctl: /[(){}\[\]\$\^|\-*+?\.]/,
    regexpesc: /\\(?:[bBdDfnrstvwWn0\\\/]|@regexpctl|c[A-Z]|x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4})/,
    // The main tokenizer for our languages
    tokenizer: {
      root: [
        [/[{}]/, "delimiter.bracket"],
        {
          include: "common",
        },
      ],
      common: [
        // identifiers and keywords
        [
          /[a-z_$][\w$]*/,
          {
            cases: {
              "@typeKeywords": "keywords",
              "@keywords": "keywords",
              "@SmoothyMethods": "method",
              "@SmoothyClasses": "class",
              "@SmoothyParams": "param",
              "@default": "identifier",
            },
          },
        ],
        [
          /[A-Z][\w\$]*/,
          {
            cases: {
              "@typeKeywords": "keywords",
              "@keywords": "keywords",
              "@SmoothyMethods": "method",
              "@SmoothyClasses": "class",
              "@SmoothyParams": "param",
              "@default": "identifier",
            },
          },
        ],
        // [/[A-Z][\w\$]*/, 'identifier'],
        // whitespace
        {
          include: "@whitespace",
        },
        // regular expression: ensure it is terminated before beginning (otherwise it is an opeator)
        [
          /\/(?=([^\\\/]|\\.)+\/([gimuy]*)(\s*)(\.|;|\/|,|\)|\]|\}|$))/,
          {
            token: "regexp",
            bracket: "@open",
            next: "@regexp",
          },
        ],
        // delimiters and operators
        [/[()\[\]]/, "@brackets"],
        [/[<>](?!@symbols)/, "@brackets"],
        [
          /@symbols/,
          {
            cases: {
              "@operators": "delimiter",
              "@default": "",
            },
          },
        ],
        // numbers
        [/(@digits)[eE]([\-+]?(@digits))?/, "number.float"],
        [/(@digits)\.(@digits)([eE][\-+]?(@digits))?/, "number.float"],
        [/0[xX](@hexdigits)/, "number.hex"],
        [/0(@octaldigits)/, "number.octal"],
        [/0[bB](@binarydigits)/, "number.binary"],
        [/(@digits)/, "number"],
        // delimiter: after number because of .\d floats
        [/[;,.]/, "delimiter"],
        // strings
        [/"([^"\\]|\\.)*$/, "string.invalid"],
        [/'([^'\\]|\\.)*$/, "string.invalid"],
        [/"/, "string", "@string_double"],
        [/'/, "string", "@string_single"],
        [/`/, "string", "@string_backtick"],
      ],

      whitespace: [
        [/[ \t\r\n]+/, ""],
        [/\/\*\*(?!\/)/, "comment.doc"],
        [/!{3}/, "comment", "@comment"],
        [/#.*$/, "comment"],
      ],
      comment: [
        [/[^!{3}}]+/, "comment"],
        // [/\/\*/, 'comment', '@push' ],    // nested comment not allowed :-(
        // [/\/\*/,    'comment.invalid' ],    // this breaks block comments in the shape of /* //*/
        [/!{3}/, "comment", "@pop"],
        [/[!{3}]/, "comment"],
      ],
      regexp: [
        [
          /(\{)(\d+(?:,\d*)?)(\})/,
          ["regexp.escape.control", "regexp.escape.control", "regexp.escape.control"],
        ],
        [
          /(\[)(\^?)(?=(?:[^\]\\\/]|\\.)+)/,
          [
            "regexp.escape.control",
            {
              token: "regexp.escape.control",
              next: "@regexrange",
            },
          ],
        ],
        [/(\()(\?:|\?=|\?!)/, ["regexp.escape.control", "regexp.escape.control"]],
        [/[()]/, "regexp.escape.control"],
        [/@regexpctl/, "regexp.escape.control"],
        [/[^\\\/]/, "regexp"],
        [/@regexpesc/, "regexp.escape"],
        [/\\\./, "regexp.invalid"],
        [
          "/",
          {
            token: "regexp",
            bracket: "@close",
          },
          "@pop",
        ],
      ],
      regexrange: [
        [/-/, "regexp.escape.control"],
        [/\^/, "regexp.invalid"],
        [/@regexpesc/, "regexp.escape"],
        [/[^\]]/, "regexp"],
        [/\]/, "@brackets.regexp.escape.control", "@pop"],
      ],
      string_double: [
        [/[^\\"]+/, "string"],
        [/@escapes/, "string.escape"],
        [/\\./, "string.escape.invalid"],
        [/"/, "string", "@pop"],
      ],
      string_single: [
        [/[^\\']+/, "string"],
        [/@escapes/, "string.escape"],
        [/\\./, "string.escape.invalid"],
        [/'/, "string", "@pop"],
      ],
      string_backtick: [
        [
          /\$\{/,
          {
            token: "delimiter.bracket",
            next: "@bracketCounting",
          },
        ],
        [/[^\\`$]+/, "string"],
        [/@escapes/, "string.escape"],
        [/\\./, "string.escape.invalid"],
        [/`/, "string", "@pop"],
      ],
      bracketCounting: [
        [/\{/, "delimiter.bracket", "@bracketCounting"],
        [/\}/, "delimiter.bracket", "@pop"],
        {
          include: "common",
        },
      ],
    },
  });

  monaco.languages.registerCompletionItemProvider("smoothy", {
    triggerCharacters: [".", " "],
    provideCompletionItems: (model, position, cancellationToken, completionContext) => {
      // get editor content before the pointer
      {
        var textUntilPosition = getVariable(model, position, cancellationToken, completionContext);
        return { suggestions: textUntilPosition };
      }
    },
  });

  function getVariable(model, position, cancellationToken, completionContext) {
    var text = model.getValueInRange({
      startLineNumber: 1,
      startColumn: 1,
      endLineNumber: model.getLineCount(),
      endColumn: model.getLineContent(model.getLineCount()).length,
    });

    var currentVariable = model.getValueInRange({
      startLineNumber: position.lineNumber,
      startColumn: 1,
      endLineNumber: position.lineNumber,
      endColumn: position.column,
    });

    if (currentVariable.includes("is") && !currentVariable.includes(".")) {
      return getSmoothyClassesIntellisense();
    } else if (currentVariable.includes(".")) {
      var lines = text.split("\n");
      var type = null;
      var lineToWorkOn = null;
      currentVariable = currentVariable.trim();
      lines.forEach((line, index) => {
        if (line.indexOf(currentVariable.split(".")[0] + " is") != -1) {
          lineToWorkOn = index;
        }
      });
      if (currentVariable.includes("program.")) {
        return [
          {
            label: "waitHere(time:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "waitHere(time:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "randnumber(max:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "randnumber(max:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "randcolor()",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "randcolor()",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onrightmousedown(eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onrightmousedown(eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onleftmousedown(eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onleftmousedown(eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onrightmouseup(eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onrightmouseup(eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onleftmouseup(eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onleftmouseup(eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onMouseMove(eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onMouseMove(key:,eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onkeydown(key:,eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onkeydown(key:,eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
          {
            label: "onkeyup(key:,eventHandler:)",
            kind: monaco.languages.CompletionItemKind.Class,
            insertText: "onkeyup(key:,eventHandler:$1)",
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          },
        ];
      }
      if (lineToWorkOn == null) {
        return null;
      } else {
        var currentLine = lines[lineToWorkOn];
        smoothyClasses.forEach((element) => {
          if (currentLine.toLowerCase().includes(element.name.toLowerCase())) {
            type = element.name;
          }
        });

        if (type != null) {
          return getSmoothyTypeIntellisense(type);
        }
      }
    } else if (currentVariable.includes("P") || currentVariable.includes("p")) {
      return [
        {
          label: "Program.waitHere(time:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.waitHere(time:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.randnumber(max:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.randnumber(max:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.randcolor()",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.randcolor()",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onrightmousedown(eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onrightmousedown(eventHandler:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onleftmousedown(eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onleftmousedown(eventHandler:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onrightmouseup(eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onrightmouseup(eventHandler:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onleftmouseup(eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onleftmouseup(eventHandler:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onMouseMove(eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onMouseMove(eventHandler:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onkeydown(key:,eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onkeydown(key:$1,eventHandler:$2)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.onkeyup(key:,eventHandler:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.onkeyup(key:$1,eventHandler:$2)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.rec_with_move(width:,hegiht:,color:,location:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.rec_with_move(width:$2,hegiht:$2,color:$2,location:$2)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.ellipse_with_move(width:,hegiht:,color:,location:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "Program.ellipse_with_move(width:$2,hegiht:$2,color:$2,location:$2))",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: "Program.polystar_with_move(radius:,sides:,color:,location:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "program.polystar_with_move(radius:$2,sides:$2,color:$2,location:$2)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
      ];
    } else if (currentVariable.includes("s") || currentVariable.includes("s")) {
      return [
        {
          label: "screen.print(text:)",
          kind: monaco.languages.CompletionItemKind.Class,
          insertText: "screen.print(text:$1)",
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
      ];
    } else if (currentVariable == "if" || currentVariable == "IF") {
      return [
        {
          label: `if !!!(condition)!!! then \n #block of code to be executed if the condition is true\nendif`,
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: `if !!!(condition)!!! then \n #block of code to be executed if the condition is true\nendif`,
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
      ];
    } else if (currentVariable == "wh" || currentVariable == "WH") {
      return [
        {
          label: `while !!!(condition)!!! do \n #block of code to be executed if the condition is true\nendwhile`,
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: `while !!!(condition)!!! do \n #block of code to be executed if the condition is true\nendwhile`,
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
      ];
    } else if (currentVariable == "el" || currentVariable == "EL") {
      return [
        {
          label: `else then \n #block of code to be executed if the condition is false\nendelse`,
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: `else then \n #block of code to be executed if the condition is false\nendelse`,
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
      ];
    } else if (currentVariable == "f" || currentVariable == "F") {
      return [
        {
          label: `function funcName\n#code goes here\nendfunction`,
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: `function funcName\n#code goes here\nendfunction`,
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
        {
          label: `for!!!VARIABLE_NAME!!!from!!! START!!!to!!!END!!!\n#code goes here\nendfor`,
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: `for!!!VARIABLE_NAME!!!from!!! START!!!to!!!END!!!\n#code goes here\nendfor`,
          insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        },
      ];
    }
    return "";
  }

  function getSmoothyClassesIntellisense() {
    var intellisense = [];
    smoothyClasses.forEach((element) => {
      if (graphicsClasses[element.name].isStatic) {
        return;
      }
      var paramsToInsert = "(";
      var params = "(";
      if (element.params) {
        var count = 1;
        element.params.forEach((param) => {
          if (params == "(") {
            params += param + ":";
            paramsToInsert += param + ":$" + count;
          } else {
            params += "," + param + ":";
            paramsToInsert += "," + param + ":$" + count;
          }
          count++;
        });
      }

      params += ")";
      paramsToInsert += ")";
      intellisense.push({
        label: element.name + params,
        kind: monaco.languages.CompletionItemKind.Class,
        insertText: element.name + paramsToInsert,
        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
      });
    });
    return intellisense;
  }

  function getSmoothyTypeIntellisense(type) {
    var methods = graphicsClasses[type].$getMethods();
    var intellisense = [];
    methods.forEach((element) => {
      var paramsToInsert = "(";
      var params = "(";
      if (element.params) {
        var count = 1;
        element.params.forEach((param) => {
          if (params == "(") {
            params += param + ":";
            paramsToInsert += param + ":$" + count;
          } else {
            params += "," + param + ":";
            paramsToInsert += "," + param + ":$" + count;
          }
          count++;
        });
      }
      params += ")";
      paramsToInsert += ")";
      intellisense.push({
        label: element.name + params,
        kind: monaco.languages.CompletionItemKind.Method,
        insertText: element.name + paramsToInsert,
        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
      });
    });
    return intellisense;
  }
}
